import { createSlice } from '../context';
export const remarkPluginsCtx = createSlice([], 'remarkPlugins');
export const remarkPluginFactory = (plugin) => () => (ctx) => {
    ctx.update(remarkPluginsCtx, (prev) => prev.concat([plugin].flat()));
};
//# sourceMappingURL=remark-plugin-factory.js.map